import React, { useContext, useEffect, useState } from 'react'
import Filters from './Filters';
import { BasePopupContext } from '../../hooks/usePopup';
import { customStringify } from '../../utils';
import axios from 'axios';
import useApi from "../../hooks/useApi";
import { network_tl } from '../../translations';
import RetryApi from '../../components/RetryApi';
import { DESENDING_ORDER, LISTING_LIMIT, ORDER_DESCENDING, POPUP_SMALL } from '../../constants';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import Card from './Card';
import AddInfluencer from './AddInfluencer';
import Loading from '../../components/Loading';
import Pagination from '../../components/Pagination';
import { useSearchParams } from 'react-router-dom';

const Container = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const create = searchParams.get('create');
  const [filters, setFilters] = useState({
    search: "",
    city: "",
    category: "",
    followers: "",
    engagement_rate: "",
    cost: "",
    sort_order: ORDER_DESCENDING
  })

  const [appliedFilters, setAppliedFilters] = useState({
    search: "",
    city: "",
    category: "",
    followers: "",
    engagement_rate: "",
    cost: "",
    sort_order: ORDER_DESCENDING
  })

  //   useEffect(() => {
  //     console.log("filters",filters)
  //  }, [filters])

  const { setPopup } = useContext(BasePopupContext);

  const [data, setData] = useState([
    {
      id: 1,
      name: "John Doe",
      city: "San Francisco",
      niche: ["test", "test", "test"],
      followers: "0",
      engagement_rate: 0,
      price_from: 0,
      price_to: 10
    },
    {
      id: 1,
      name: "Doe John",
      city: "test",
      niche: ["test", "test", "test"],
      followers: 0,
      engagement_rate: 0,
      price_from: 0,
      price_to: 10
    },
    {
      id: 1,
      name: "Emily Mikeson",
      city: "test",
      niche: ["test", "test", "test"],
      followers: 0,
      engagement_rate: 0,
      price_from: 0,
      price_to: "100K",
      img: null
    },

  ])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
  let offset = 0;

  const intl = useIntl();
  const { Axios } = useApi();

  const getData = async (curr) => {
    try {
      setLoading(true);
      setError(false);
      if (curr) {
        offset = 0;
      }
      else if (count) {
        offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
      } else {
        offset = 0;
      }
      const result = await Axios.get(`api/user/listing-agency-influencer?limit=${LISTING_LIMIT}&offset=${offset}&search=${appliedFilters.search.trim()}`);
      setData(result.data.payload);
      setLoading(false);
      setCount(result.data.count)
    } catch (e) {
      if (axios.isCancel(e)) {

      } else if (e.response) {
        setError(customStringify(e.response.data.description))
        setLoading(false)
      } else {
        setError(network_tl(intl))
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    getData()
  }, [currentPage, sort])

  useEffect(() => {
    getData(1)
  }, [appliedFilters])

  const applyFilters = () => {
    const copy = _.cloneDeep(filters)
    setCurrentPage(1);
    setAppliedFilters(copy)
  }

  const resetFilters = () => {
    setCurrentPage(1)
    setFilters({
      search: "",
      city: "",
      category: "",
      followers: "",
      engagement_rate: "",
      cost: "",
      sort_order: ORDER_DESCENDING
    })
    setAppliedFilters({
      search: "",
      city: "",
      category: "",
      followers: "",
      engagement_rate: "",
      cost: "",
      sort_order: ORDER_DESCENDING
    })
  }

  const refreshListing = () => {
    setCurrentPage(1);
    getData(1)
  }


  useEffect(() => {
    if (create) {
      setPopup({
        heading: <FormattedMessage id="add_new_influencer" defaultMessage={"Add New Influencer"} />,
        component: <AddInfluencer refreshListing={refreshListing} create={create} />,
        size: POPUP_SMALL
      })
    }
  }, [create])


  const handleNewUser = () => {
    setPopup({
      heading: <FormattedMessage id="add_new_influencer" defaultMessage={"Add New Influencer"} />,
      component: <AddInfluencer refreshListing={refreshListing} />,
      size: POPUP_SMALL
    })
  }
  return (
    <div className='container py-5'>
      <Filters
        filters={filters}
        setFilters={setFilters}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
        appliedFilters={appliedFilters}

      />


      <div className='py-5'>
        <div className='flex justify-end space-x-3 mb-8'>
          <button
            onClick={handleNewUser}
            type="button"
            className='btn w-auto text-center btn-primary'
          >
            <p>
              <FormattedMessage id="add_influencer" defaultMessage={"Add New Influencer"} />
            </p>
          </button>
        </div>

        {loading ?
          <div className='flex justify-center'>
            <Loading />
          </div>
          :
          error ?
            <>
              <RetryApi error={error} retry={getData} />
            </>
            :

            <>
              {
                data.length > 0 ?
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2k:grid-cols-5 gap-5 justify-items-center '>
                  {data.map((item, index) => {
                    return (
                      <Card item={item} key={index} refreshListing={refreshListing} />
                    );
                  }
                )}
                </div>
                  :
                  <div className="text-t-light flex justify-center w-full text-center mt-5">
                    <FormattedMessage id="no_data_found" defaultMessage="No Data Found" />
                  </div>
              }
            <div className="flex my-10 justify-end">
                <Pagination
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  perPage={LISTING_LIMIT}
                  offset={offset}
                  total_pages={Math.ceil(count / LISTING_LIMIT)}
                  count={count} />
              </div></>

          // <Table
          //   refreshListing={refreshListing}
          //   data={data}
          //   loading={loading}
          //   setSort={setSort}
          //   currentPage={currentPage}
          //   setCurrentPage={setCurrentPage}
          //   count={count}
          // />
        }


      </div>
    </div>
  )
}

export default Container